// extracted by mini-css-extract-plugin
export default {"actLikeAChip":"AddContentButton_actLikeAChip__LI1X8"};